export enum ErrorCase {
    USER_CONSENT_FAILED,
    RECORDER_TIMEOUT,
    ALREADY_RECORDING
}